export default "https://widget.myclimate.org/assets/images/kenia.jpg";